export default __webpack_public_path__ + "static/media/1646.fb4eb11b.png";